<div class="modal-header blue">
  <h4 class="modal-title">
    {{
      isFirstStep ? 'Add Provider Setup 1/2' : 'Add Provider ID Information 2/2'
    }}
  </h4>
  <a href="javascript:void(0)" class="modal-close-btn" (click)="close()"></a>
</div>

<form [formGroup]="providerForm">
  <div
    class="modal-body provider"
    [class.next-step]="!isFirstStep"
    [class.loading]="isLoading"
  >
    <div class="provider-step">
      <div class="row mb-3">
        <div class="col">
          <div class="mb-3">
            <div class="input-label">
              <span class="standart-text-required-symbol">*</span>
              First name
            </div>
            <input
              type="text"
              placeholder="Enter First Name"
              class="input"
              formControlName="firstName"
              maxLength="35"
            />

            <div
              class="invalid-feedback d-block text-left"
              *ngIf="
                providerForm.get('firstName')?.invalid &&
                providerForm.get('firstName')?.touched
              "
            >
              <span *ngIf="providerForm.get('firstName')?.errors?.required"
                >This field is required</span
              >
            </div>
          </div>

          <div class="mb-3">
            <div class="input-label">
              <span class="standart-text-required-symbol">*</span>
              last name
            </div>
            <input
              type="text"
              placeholder="Enter Last Name"
              class="input"
              formControlName="lastName"
              maxLength="65"
            />

            <div
              class="invalid-feedback d-block text-left"
              *ngIf="
                providerForm.get('lastName')?.invalid &&
                providerForm.get('lastName')?.touched
              "
            >
              <span *ngIf="providerForm.get('lastName')?.errors?.required"
                >This field is required</span
              >
            </div>
          </div>

          <div class="mb-3">
            <div class="input-label">mi</div>
            <input
              type="text"
              placeholder="Enter MI"
              class="input"
              formControlName="mi"
              maxlength="1"
            />
          </div>

          <div class="mb-3">
            <div class="input-label">degree</div>
            <input
              type="text"
              placeholder="Enter Degree"
              class="input"
              formControlName="degree"
              maxlength="5"
            />
          </div>

          <div class="">
            <ddl-practice formControlName="pms"></ddl-practice>
          </div>
        </div>

        <div class="col">
          <section-contact formGroupName="contact"></section-contact>
        </div>

        <div class="col">
          <div class="mb-3">
            <section-status-dates
              [formGroup]="providerForm"
              [isEditMode]="false"
            >
            </section-status-dates>
          </div>

          <div class="mb-3">
            <div class="input-label">
              <span class="standart-text-required-symbol">*</span>
              certification status
            </div>
            <div
              class="d-flex"
              [class.disabled]="providerForm.get('certified')?.disabled"
            >
              <label class="input-wrap radio mr-3">
                <input type="radio" value="P" formControlName="certified" />
                <span class="text">Production</span>
              </label>
              <label class="input-wrap radio">
                <input type="radio" value="T" formControlName="certified" />
                <span class="text">Test</span>
              </label>
            </div>
          </div>

          <div>
            <div class="input-label">
              <span class="standart-text-required-symbol">*</span>
              fee schedule
            </div>
            <div class="input-wrap select">
              <select class="input" formControlName="feeSchedule">
                <option [value]="''" selected="selected" disabled>
                  Select Fee Schedule
                </option>
                <ng-container *ngFor="let fee of fees$ | async">
                  <option [value]="fee.id" title="{{ fee.name }}">
                    {{ fee.name }}
                  </option>
                </ng-container>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <section-address formGroupName="address"></section-address>
        </div>
      </div>
    </div>

    <div class="provider-step">
      <qualifiers-grid [groupId]="groupId" [isProvider]="true">
      </qualifiers-grid>
    </div>
  </div>

  <div class="modal-footer">
    <button *ngIf="isFirstStep" class="button ml-auto w-80px" (click)="next()">
      Next
    </button>
    <button class="button-outline" *ngIf="!isFirstStep" (click)="previous()">
      Previous
    </button>
    <button
      class="button w-80px"
      *ngIf="!isFirstStep"
      (click)="save()"
      [disabled]="providerForm.invalid"
    >
      Save
    </button>
  </div>
</form>
